import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

const cyptoNewsHeader = {
    'X-BingApis-SDK': 'true',
    'X-RapidAPI-Key': '91ee9e1306msh142cdfa6118c7e9p1f61b7jsn44ef20451ad7',
    'X-RapidAPI-Host': 'bing-news-search1.p.rapidapi.com'
  }
const baseUrl = 'https://bing-news-search1.p.rapidapi.com';

const createRequest = (url) => ({url, headers: cyptoNewsHeader});

export const cryptoNewsApi = createApi({
    reducerPath: 'cryptoNewsApi',//the name
    baseQuery: fetchBaseQuery({ baseUrl}),//function que recibe el objeto url
    endpoints: (builder) => ({
        getCryptoNews: builder.query({
            query: ({newsCategory, count}) => createRequest(`/news/search?q=${newsCategory}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`)
        })

    })
});
export const {
    useGetCryptoNewsQuery,
} = cryptoNewsApi;
